import { useEffect, useState } from "react"
import Axios from "axios"
import AbortController from 'abort-controller';

import infoIcon from "../../assets/images/infoBlue.svg"

export default function MapboxInput(props) {
    const {
        option,
        optionValue,
        handleCurrentInput,
        handleOptions,
        handleShowInfo
    } = props

    const [search, setSearch] = useState(optionValue ?? "")
    const [citiesList, setCitiesList] = useState([])
    const [citiesListClass, setCitiesListClass] = useState("")

    async function handleSearch(e) {
        const { value } = e.target

        setSearch(value)

        if (value === "") {
            handleOptions("", option.accessKey)
        } 
    }
    
    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        
        async function getCoordenates() {
            try {
                const { data } = await Axios.get(
                    `https://api.mapbox.com/geocoding/v5/mapbox.places/${search}.json?types=place&access_token=${process.env.REACT_APP_MAPBOXTOKEN}`,
                    { signal }
                );

                setCitiesList(data.features)
            } catch (error) {
                if (!Axios.isCancel(error)) {
                    console.log(error)
                }    
            }
        }

        getCoordenates()

        return () => {
            controller.abort()
        }
    }, [search])

    useEffect(() => {
        setSearch(optionValue)
    }, [optionValue])

    return (
        <div className="optionContainer">
            <div className="icon-title-container">
                <span>{option.title}</span>
                <img className="d-lg-none mobile-info-icon" src={infoIcon} alt="Prodensa Teaser" onClick={() => handleShowInfo(option.accessKey)} />
            </div>

            <div className="mapbox-input-container" onFocus={() => setCitiesListClass("show")} onBlur={() => setCitiesListClass("")}>
                <input
                    onFocus={() => handleCurrentInput(option.accessKey)}
                    type="text"
                    placeholder="Insert city for headquarters"
                    value={search?.place_name ?? search}
                    onChange={handleSearch}
                />

                <div className={`citiesList ${citiesListClass}`}>
                    {citiesList?.map(city => {
                        return (
                            <span
                                key={city.id}
                                onClick={() => handleOptions(city, option.accessKey)}
                            >
                                {city.place_name}
                            </span>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
